import classNames from 'classnames';
import React from 'react';

import { IconButton } from '@wetransfer/transfer/oneui/react/Icon';

import styles from './Pill.module.scss';

export type PillShapes = 'round' | 'square';

export type PillSizes = 'default' | 'small';

export interface PillProps {
  textContent: string;
  variant?: string;
  shape?: string;
  size?: string;
  className?: string;
  isDismissible?: boolean;
  closeCallback?: () => void;
}

const Pill: React.FC<PillProps> = ({
  textContent,
  variant = 'success',
  shape = 'round',
  size = 'default',
  className,
  isDismissible = false,
  closeCallback,
}) => {
  return (
    <span
      className={classNames(
        styles.Pill,
        [styles[`Pill--${variant}`]],
        [styles[`Pill--${size}`]],
        [styles[`Pill--${shape}`]],
        className
      )}
      data-testid="pill"
    >
      <span>{textContent}</span>
      {isDismissible && (
        <IconButton
          className={classNames([styles['Pill--dismiss-button']])}
          name={variant.includes('error') ? 'close--error' : 'close--primary'}
          onClick={closeCallback}
          size={10}
        />
      )}
    </span>
  );
};

export default Pill;
